<script>
export default {
    name: 'OnClickOutside',

    props: {
        except: {type: String, default: null},
    },

    mounted() {
        const listener = (event) => {
            if (this.except && event.target.closest(this.except)) {
                return;
            }

            if (event.target === this.$el || this.$el.contains(event.target)) {
                return;
            }

            this.$emit('click');
        };

        document.addEventListener('click', listener, true);

        this.$once('hook:beforeDestroy', () => {
            document.removeEventListener('click', listener, true);
        });
    },

    render() {
        if (!this.$scopedSlots.default) {
            return null;
        }

        return this.$scopedSlots.default();
    },
};
</script>
